module fdm.flightLegs {

    export class ProjectsService {


        public constructor(
            private actionService: dg.actions.ActionService) {
        }

        //private projects(): restangular.IElement {
        //    return this.DgRestangular.all('project');
        //}

        //public projectDefinitionCommand(): restangular.IElement {
        //    return this.DgRestangular.one('project').one('define-project');
        //}

        //public projectGeneralQuery(projectId) {
        //    return this.DgRestangular.one('project', projectId).one('project-general');
        //}

        //public projectProductFileTypesListQuery(fileOwnerId: string): ng.IPromise<IOwnerFileTypeListQueryResult>{
        //    return this.DgRestangular.one('owner-file-type/owner-file-type-list/result').get({
        //        fileOwnerId: fileOwnerId,
        //        fileTypeClassId: FileTypeClass.Product
        //    });
        //}

        //public projectOperationalFileTypesListQuery(fileOwnerId: string): ng.IPromise<IOwnerFileTypeListQuery> {
        //    return this.DgRestangular.one('owner-file-type/owner-file-type-list').get({
        //        fileOwnerId: fileOwnerId,
        //        fileTypeClassId: FileTypeClass.Operational
        //    });
        //}

        //public productFileQuery(fileOwnerId: string) {
        //    return this.DgRestangular.one('file-descriptor/product-files').get({
        //        fileOwnerId: fileOwnerId,
        //    });
        //}

        //public operationalFilesQuery(parentId: string) {
        //    return this.DgRestangular.one('file-descriptor/operational-files').get({
        //        parentId: parentId
        //    });
        //}

        //public projectOverviewQuery(projectId) {
        //    return this.DgRestangular.one('project', projectId).one('project-overview');
        //}

        //public updateProjectCommand(projectId) {
        //    return this.DgRestangular.one('project', projectId).one('update-project');
        //}

        //public loadMyProjectsListQuery(): ng.IPromise<IMyProjectsListQuery> {
        //    return this.DgRestangular.one('project/my-project-list').get();
        //}
    }

    angular.module('fdm.flightLegs')
        .service('projectsService', ProjectsService);
}